import React from 'react'
import LoadingAnimation from "../components/LoadingAnimation";
import ReactDOM from "react-dom"
import {addToLogBuffer, getServerIfState, SERVER_IF_BG_TASK, SERVER_IF_NOT_BUSY} from "./ProsConnect";

const DELAY_AUTO_CLOSE_NOTIF_MS = 3000
let notifTimer = null;

let notifText = null
let dismissButton = null
let cancelButton = null
let showWaitSpinner = null
let notifClassExtra = null

/***
 * Notification is shown as a "react stateless" html element by refreshing index.html div element.
 * Note this does not use normal rendering and do not use state to avoid rendering react main DOM.
 * Examples:
 *
 *    prosAppNotif("Saving user settings")
 *    prosAppNotifWarn("No permission to change")
 *    prosAppNotif("Requested operation started", {
                    title: "Title for notification",
                    type: "notice",
                    action: () => { console.log("Pressed"); prosAppNotifDismiss() },
                    icon: 'edit',
                    buttonText: "Button text"
                })
 *
 */

/**
 * To show one liner notification that either closes automatically as "toast" or dismissed by end user.
 * @param text  - notification text
 * @param notifParam - an optional object for notification additional parameters
 *                  type: "notice": (orange), "warning": (red), when missing default style is used
 *         dismissByUser: true when user is requested to close / confirm notification
 *              showWait: true to show a "progress spinner" used when operation may last longer than a few seconds
 *                 title: an optional title in addition to text
 *        --- info for extra button ---
 *                action: callback action when button is pressed
 *                  icon: css (class) for button
 *            buttonText: button text
 */
export default function prosAppNotif(text, notifParam) { // type, dismissByUser, showLoadingSpinner, notifButtonSettings
    // Add notification into user feedback log
    addToLogBuffer('NOTIF:' + text)
    let param = notifParam || {}
    notifText = param.title
            ? <section><h2>{param.title}</h2><p>{text}</p></section>
            : text ? <section><p>{text}</p></section> : null
    notifClassExtra = (param.type ? " notification-" + param.type : "")
    dismissButton = param.dismissByUser ?
        <button onClick={() => prosAppNotifDismiss()}
            className={"btn btn-primary btn-icon btn-icon-left btn-icon-check"}
            ><span>Sulje</span>
        </button>
        : null

    let hasCustomAction = typeof param.action === 'function'
    cancelButton = hasCustomAction ?
        <button
            onClick={() => param.action()}
            className={"btn btn-primary btn-icon btn-icon-left btn-icon-" + (param.icon || 'check')}
            >
            <span>{param.buttonText || 'OK'}</span>
        </button>
        : null

    showWaitSpinner = param.showWait

    if (notifTimer) {
        clearTimeout(notifTimer)
    }

    if (!text) {
        prosAppNotifDismiss()
    }

    if (!dismissButton && !hasCustomAction) {
        notifTimer = setTimeout(() => {
            prosAppNotifDismiss()
        }, DELAY_AUTO_CLOSE_NOTIF_MS)
    }
    updateNotifHtmlElement()
}

export function prosAppNotifWait(text)        { prosAppNotif(text, {showWait: true}) }
export function prosAppNotifNotice(text)      { prosAppNotif(text, {type: "notice"})  }
export function prosAppNotifWarn(text)        { prosAppNotif(text, {type: "warning"}) }
export function prosAppNotifConfirm(text)     { prosAppNotif(text, {dismissByUser: true}) }
export function prosAppNotifWarnConfirm(text) { prosAppNotif(text, {type: "warning", dismissByUser: true}) }

/**
 * Notification will dismiss autonomously unless wanted to stay active until dismissed by app code using this
 */
export function prosAppNotifDismiss() {
    notifTimer = null
    notifText = null
    dismissButton = null
    cancelButton = null
    showWaitSpinner = null
    notifClassExtra = null
    updateNotifHtmlElement()
}

export function updateNotifHtmlElement() {
    let notifHtml = null
    let busyState = getServerIfState()
    if (notifText || showWaitSpinner) {
        //Todo: improve this - stupid way but needs to be done quickly because of release
        let spinnerBgColor = notifClassExtra.indexOf("notice") > -1 ? "var(--color-2nd)" : "var(--color-gray-80)"
        if(notifClassExtra.indexOf("warning") > -1) spinnerBgColor = "var(--color-no-c7)"
        // Showing normal notification
        notifHtml = <div id="prosNotif" className={"element-set notification show " + notifClassExtra || ""}>
            {notifText}
            {showWaitSpinner || busyState !== SERVER_IF_NOT_BUSY ?
                <LoadingAnimation type={"arrows_mask"}  bg={spinnerBgColor} />
                : null
            }
            {(dismissButton || cancelButton ?
                <footer>
                    <div className={"btn-set"}>{cancelButton}{dismissButton}</div>
                </footer> : null)}
        </div>
    } else {
        if(busyState !== SERVER_IF_NOT_BUSY){
            notifHtml = <div id={"busy-indicator"} className={"busy-indicator"}>
                {busyState === SERVER_IF_BG_TASK ? <LoadingAnimation type={"arrows"} /> : <LoadingAnimation type={"arrows_mask"}  bg={"var(--color-gray-10)"} />}
            </div>
        }
    }
    ReactDOM.render(
        notifHtml,
        document.getElementById("prosAppNotif")
    )
}